var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_vm._t("actions",null,{"loading":_vm.submitting,"on":_vm.submit})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }